<div class="resp-container" [ngClass]="isRemebered==null ? '' : isRemebered ?  'remember' : 'not-remember'">
    <div class="close-btn-box" (click)="close()">
        <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/cross-icon-light.svg" class="close-icon" />
    </div>
    
    <div class="container" [@fadeOutRightBig]="toRight" [@fadeOutLeftBig]="toLeft">
        <div class="card" [@flipState]="flip">
            <div class="front" (click)="flipCard($event)">
              <div class="d-flex flex-row justify-content-between mem-card-header">
                  <h4 class="question-text">Question</h4>
                  <span class="mem-card-count">{{currentQuestionNumber+1}}/{{questionsData?.length}}</span>
              </div>
              <hr class="hr-rule" />
              <div class="SLV2-card-cnt-area">
                <h2 class="mem-card-question" [mathMl]="currentQuestionData?.front.text"></h2>
                <ng-container *ngIf="currentQuestionData?.front.imageURL"> <img [src]="currentQuestionData?.front.imageURL" class="mem-card-question-img" /></ng-container>
              </div>
              <span class="tab-to-see-text">Tap to see answer</span>
            </div>
            <div class="back" (click)="flipCard($event)">
              <div class="d-flex flex-row justify-content-between mem-card-header-back">
                  <h4 class="question-text">Answer</h4>
                  <span class="mem-card-count">{{currentQuestionNumber+1}}/{{questionsData?.length}}</span>
              </div>
              <hr class="hr-rule-back" />
              <div class="SLV2-card-cnt-area">
                <h2 class="mem-card-question" [mathMl]="currentQuestionData?.back.text"></h2>
                  <ng-container *ngIf="currentQuestionData?.back.imageURL"> <img [src]="currentQuestionData?.front.imageURL"
                    class="mem-card-question-img" /></ng-container>
              </div>
              <div class="rem-donrem-btn-box d-flex flex-row justify-content-end">
                <!-- <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/I-dont-remember-btn.png" class="ans-btn" (click)="onLeft()" />
                <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/I-remember-btn.png" class="ans-btn" (click)="onRight()" /> -->
                <button class="ans-btn" (click)="onLeft()">I don’t remember</button>
                <button class="ans-btn" (click)="onRight()">I remember</button>
              </div>
            </div>
          </div>
    </div>
    <!-- <div class="container" *ngIf="currIndex == 1" [@fadeOutRightBig]="toRight" [@fadeOutLeftBig]="toLeft">
        <div class="card" [@flipState]="flip">
            <div class="front">
              <div class="d-flex flex-row justify-content-between mem-card-header">
                  <h4 class="question-text">Question</h4>
                  <span class="mem-card-count">3/10</span>
              </div>
              <hr class="hr-rule" />
              <h2 class="mem-card-question">Large transformers, become hot and are cooled by circulating oil.</h2>
              <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/sample-question2.svg" class="mem-card-question-img" />
              <span class="tab-to-see-text" (click)="flipCard()">Tab to see answer</span>
            </div>
            <div class="back">
              <div class="d-flex flex-row justify-content-between mem-card-header-back">
                  <h4 class="question-text">Answer</h4>
                  <span class="mem-card-count">3/10</span>
              </div>
              <hr class="hr-rule-back" />
              <h2 class="mem-card-question">Large transformers, become hot and are cooled by circulating oil.</h2>
              <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/sample-question2.svg" class="mem-card-question-img" />
              <div class="rem-donrem-btn-box d-flex flex-row justify-content-end">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/I-dont-remember-btn.png" class="ans-btn" (click)="onLeft()" />
                <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/I-remember-btn.png" class="ans-btn" (click)="onRight()" />
              </div>
            </div>
          </div>
    </div> -->
    
</div>
